const sugerenciaInitialState = {
    sugerencia: {
        loading: false,
        error: null,
        data: null
    },
};

export default sugerenciaInitialState;